import React, { useState } from "react";
import "twin.macro";
import CurrencyFormat from "react-currency-format";
import { currency } from "../../lib/helpers/currencySymbol";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import AccountDetailsCard from "../AccountDetailsCard/AccountDetailsCard";
import Auth from "../../lib/middleware/auth";
import { Image, message, Modal, Switch } from "antd";
import Paystack from "../../assets/images/paystack.png";
// import Paystack from "../../assets/svg/paystack.svg";
import lock from "../../assets/svg/lock.svg";
import {
	AnonymousWrapper,
	ButtonGroup,
	DisclaimerText,
	DonateWrapper,
	HelperText,
	InputContainer,
	LabelWrapper,
	LightPinkButton,
	PinkButton,
	SecuredOptionText,
} from "./component";
import { useInitializePayment } from "../../redux/api/Transaction";
import { PageLoading } from "../Loading/Loading";
import PinInput from "../PinInput/PinInput";
import errorHandler from "../../redux/actions/errorHandler";
import { ModalContainer, ModalTitle } from "../PinInput/component";
import { GatewayButton } from "../../lib/styles/styleLibrary";

const Donate = ({ walletDt, setAccountSelected, accountSelected }) => {
	const { symbol } = Auth.getCurrency();
	const user = Auth.getUser();
	const [amount, setAmount] = useState("");
	const [pinVisible, setPinVisible] = useState(false);
	const [isGatewayVisible, setIsGatewayVisible] = useState(false);
	const [pin, setPin] = useState("");
	const [anonymous, setAnonymous] = useState(false);
	const [gateway, setGateway] = useState("");
	const curr = symbol?.split("+").pop();

	const { mutateAsync: handlePay, isLoading, error } = useInitializePayment();

	const handleWalletPay = async () => {
		if (isEmpty(user)) {
			Toast.fire({
				icon: "error",
				title: `An error occurred, please try again later`,
			});
			return;
		}
		const data = {
			purpose: "donation",
			amount: amount,
			payment_gateway: gateway,
			email: user.email,
			weddingId: user.weddingId,
			currencyCode: "NGN", //user.currency.code,
			walletPin: pin,
		};
		try {
			const res = await handlePay(data);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			if (gateway === "wallet") {
				return Toast.fire({
					icon: "success",
					title: `${res.data.message}`,
				});
			}
			const { authorization_url } = res.data.data.data;
			Toast.fire({
				icon: "success",
				title: `You will be redirected to payment page`,
			});
			setTimeout(() => {
				window.location.href = `${authorization_url}`;
			}, 500);
		} catch (err) {
			console.log("the pay error", error);
		} finally {
			setPin("");
		}
	};

	const handlePinInput = () => {
		if (isEmpty(amount)) {
			Toast.fire({
				icon: "error",
				title: `Please enter a valid amount for payment`,
			});
			return;
		}
		setPinVisible(true);
	};

	return (
		<DonateWrapper>
			{isLoading && <PageLoading />}
			{!isEmpty(walletDt) && (
				<AccountDetailsCard
					virtualAccounts={walletDt}
					setAccountSelected={setAccountSelected}
					accountSelected={accountSelected}
				/>
			)}

			<InputContainer>
				<LabelWrapper>Enter an amount to donate</LabelWrapper>

				<CurrencyFormat
					value={amount}
					allowNegative={false}
					displayType={"input"}
					thousandSeparator={true}
					placeholder={"00.00"}
					type="tel"
					decimalScale={2}
					fixedDecimalScale={true}
					onValueChange={(values) => {
						const { value } = values;
						setAmount(value);
					}}
					prefix={currency(curr)}
				/>
			</InputContainer>
			<HelperText>Charges may apply</HelperText>

			<AnonymousWrapper>
				<LabelWrapper>Anonymous</LabelWrapper>
				<Switch
					size="small"
					style={{ backgroundColor: anonymous ? "red" : "#c1cacf" }}
					checked={anonymous}
					onChange={() => {
						setAnonymous(!anonymous);
						message.info(
							!anonymous
								? "Now donating as Anonymous 👤"
								: "Donor is now visible to couples 😎"
						);
					}}
				/>
			</AnonymousWrapper>

			<ButtonGroup>
				<LightPinkButton
					onClick={() => {
						if (isEmpty(amount)) {
							Toast.fire({
								icon: "error",
								title: `Please enter a valid amount for payment`,
							});
							return;
						}
						setGateway("paystack");
						setIsGatewayVisible(true);
					}}>
					Donate with Card
				</LightPinkButton>

				<PinkButton
					onClick={() => {
						setGateway("wallet");
						handlePinInput();
					}}>
					Donate with wallet
				</PinkButton>
			</ButtonGroup>

			<PinInput
				pin={pin}
				isVisible={pinVisible}
				goBack={() => {
					setPinVisible(false);
					setPin("");
				}}
				setPin={(v) => setPin(v)}
				continueTask={() => {
					setPinVisible(false);
					handleWalletPay();
				}}
			/>
			<Modal
				footer=""
				visible={isGatewayVisible}
				centered
				destroyOnClose={true}
				onCancel={() => setIsGatewayVisible(false)}
				maskClosable={false}>
				<ModalContainer>
					<ModalTitle>Select preferred payment gateway</ModalTitle>
					<GatewayButton
						icon={
							<Image
								preview={false}
								src={Paystack}
								alt=""
								width={18}
								height={16}
								tw="mr-5 absolute inset-3"
							/>
						}
						size={"large"}
						onClick={() => handleWalletPay()}>
						Paystack
					</GatewayButton>

					<DisclaimerText>
						Payment Processor Fees may apply. See{" "}
						<a
							href="https://"
							style={{
								textDecoration: "none",
								color: "inherit",
							}}>
							FAQ
						</a>
					</DisclaimerText>
					<SecuredOptionText>
						Secured options{" "}
						<Image
							preview={false}
							src={lock}
							alt=""
							width={18}
							height={16}
						/>
					</SecuredOptionText>
				</ModalContainer>
			</Modal>
		</DonateWrapper>
	);
};

export default Donate;
